export function isAdmin(user) {
  return user?.isAdmin || false;
}